import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { GiftCardPurchaseFormService } from '../gift-card-purchase-form/gift-card-purchase-form.service';

@Component({
    selector: 'ols-gift-card-sender-information',
    templateUrl: './sender-information.component.html',
    styleUrls: ['./sender-information.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class SenderInformationComponent {
    get senderFirstName() {
        return this.formService.form.get('senderFirstName');
    }

    get senderLastName() {
        return this.formService.form.get('senderLastName');
    }

    get senderEmail() {
        return this.formService.form.get('senderEmail');
    }

    constructor(private formService: GiftCardPurchaseFormService) {}

    submitForm() {
        this.formService.submitForm();
    }
}
